<template>
  <div class="home">
    <div class="row">
      <div class="authedUser" v-if="validUser">
        <div class="time-of-day">
          <div class="greeting left">{{ timeOfDay() }} {{ user.name }}</div>
         
          <div class="clear"></div>
        </div>
     

      </div>

      <div class="no-auth" >
        <div class="learners-banner">
          <div
            class="bg-element"
            v-bind:style="{ backgroundImage: 'url(' + pattern + ')' }"
          ></div>
          <div class="col s12 l9 m10 no-float center-aligned">
            <div class="col s12 input-field">
              <input
                type="text"
                id="appSearch"
                class="white"
                name="appSearch"
                ref="appSearch"
                value=""
                v-on:keyup.enter="$_getSearchResults()"
              />
              <label for="appSearch"></label>
              <button
                @click="$_getSearchResults()"
                class="btn-floating transparent z-depth-0 waves-effect action"
              >
                <i class="material-icons grey-text text-darken-3">search</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from "@/services/authService";
import { mapState } from "vuex";
import { getOfficeByCategory, getCategories } from "@/services/index";
import contentService from "@/services/contentService";
import pattern from "@/assets/future_web.svg";
export default {
  name: "home",
  components: {
  },
  data() {
    return {
      pattern,
      page: {},
      validUser: false,
      noAuth: false,
      latestNews: [],
      ready: false,
    };
  },
  mounted() {
    this.$_getCategories();
    this.isValidUser();
  },
  computed: {
    ...mapState({
      categories: (state) => state.categories,
      user: (state) => state.user,
    }),
    dataBanner: {
      get() {
        return this.page.id ? this.page.acf.slider_block : false;
      },
    },
  },
  methods: {
    formatDate(d) {
      return d;
    },
    timeOfDay() {
      let today = new Date();
      let curHr = today.getHours();
      if (curHr < 12) {
        return "Good Morning";
      } else if (curHr < 18) {
        return "Good Afternoon";
      } else {
        return "Good Evening";
      }
    },
    $_getCat(categories) {
      if (!categories || categories.length <= 0 || this.categories.length < 0)
        return "Featured";
      const cat = this.categories.find(({ id }) => id == categories[0]);
      if (!cat) return "Featured";
      return cat.name;
    },
    $_getCategories() {
      getCategories().then((res) => {
        this.$store.commit("SET_CATEGORIES", res.data);
      });
    },
    isValidUser() {
      authService
        .validate()
        .then((res) => {
          if (res) this.validUser = true;
          this.$_getContent();
          this.$_whatsNew();
        })
        .catch((err) => {
          if (err) this.noAuth = true;
        });
    },
    $_getContent() {
      contentService.getByTypeAndId("hrd", 4429).then((x) => {
        this.page = x.data;
        this.ready = true;
      });
    },
    $_whatsNew() {
      getOfficeByCategory(159).then((res) => {
        this.latestNews = res.data;
      });
    },
    $_getSearchResults() {
      /*   let queryVars = this.$refs.appSearch.value
      router.push({name:'search', query:{q:queryVars}}) */
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  min-height: calc(90vh - 56px);
  @media screen and (min-width: 1024px) {
    width: 100%;
    padding-left: 300px;
  }
  .banner-block-section {
    padding: 20px 8px 14px;
  }
  input#appSearch {
    border: none;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.09),
      0 3px 1px -2px rgba(0, 0, 0, 0.02), 0 1px 5px 0 rgba(0, 0, 0, 0.02) !important;
    border-radius: 8px;
    margin-top: 34px;
    padding: 0px 24px;
    width: calc(100% - 48px);
  }
  button.action {
    position: absolute;
    right: 19px;
    bottom: 10px;
  }

  .learners-banner {
    background: rgb(250, 250, 250);
    padding: 46px 48px;
    background-size: 50%;
    background-position: right top;
    background-repeat: no-repeat;
    height: 300px;
    position: relative;
    overflow: hidden;
    @media screen and (max-width: 768px) {
      padding: 24px 28px;
    }
    .bg-element {
      position: absolute;
      top: 0;
      right: 0px;
      height: calc(100% + 64px);
      width: 45%;
      background-size: cover !important;
    }
    .user-title {
      font-size: 32px;
      margin: 12px 0px;
      line-height: 1;
    }
    .short-text {
      p {
        font-size: 17px;
        line-height: 1.6;
        opacity: 0.9;
        margin: 4px 0px 16px;
      }
    }
  }
}
.greeting {
  font-size: 19px;
  line-height: 102px;
  padding-left: 31px;
  height: 74px;
}
.list-highlights {
  display: flex;
  height: 100%;
  flex-direction: column;
  .card {
    border-radius: 6px;
    box-shadow: none;
    height: calc(380px / 3);
    // background: transparent;
    border: 1px solid rgba(23, 44, 48, 0.1);
    margin-bottom: 10px;
    margin-top: 0px;
    .card-content {
      padding: 20px;
      display: flex;
      align-items: center;
      .card-content-wrapper {
        position: relative;
        width: calc(100% - 48px);
        .card-title {
          font-size: 18px;
          color: #434343;
          line-height: 1.3;
          font-family: "Source Sans Pro", sans-serif;
          font-weight: 600;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow: hidden;
          -webkit-box-orient: vertical;
        }
      }
    }
    &:hover {
      background: #fff;
      transition: 0.25s;
      box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    .category {
      color: #172c30;
      font-size: 12px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 2px;
    }
    .date {
      color: #767676;
      font-size: 13px;
    }

    .view-btn {
      position: absolute;
      right: 16px;
    }
  }
}
</style>